import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors ${
    isActive ? "text-oxblood" : "text-ink hover:text-oxblood"
  }`;

export default function PublicNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header
      className="sticky top-0 z-40 bg-parchment/85 backdrop-blur-xl border-b border-line"
      data-testid="public-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-8 h-8 bg-oxblood text-parchment flex items-center justify-center h-serif text-lg">
            C
          </div>
          <div className="leading-tight">
            <div className="h-serif text-xl text-ink">Campbell&apos;s</div>
            <div className="overline -mt-0.5">Commodities Brokerage</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">Home</NavLink>
          <NavLink to="/process" className={linkCls} data-testid="nav-process">How It Works</NavLink>
          <NavLink to="/commodities" className={linkCls} data-testid="nav-commodities">Commodities</NavLink>
          <NavLink to="/suppliers" className={linkCls} data-testid="nav-suppliers">Suppliers</NavLink>
          <NavLink to="/about" className={linkCls} data-testid="nav-about">About</NavLink>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <button
                onClick={() => nav(user.role === "admin" ? "/admin" : "/dashboard")}
                className="text-sm text-ink hover:text-oxblood"
                data-testid="nav-dashboard"
              >
                {user.role === "admin" ? "Admin" : "Dashboard"}
              </button>
              <button onClick={async () => { await logout(); nav("/"); }}
                      className="text-sm text-sub hover:text-ink" data-testid="nav-logout">
                Sign out
              </button>
            </>
          ) : (
            <Link to="/login" className="btn-primary !py-2.5 !px-5 text-sm" data-testid="nav-request-access">
              Request Access
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
